<template>
  <div>
    <div>
      <b-button variant="outline-success" class="float-right" @click="redirecionar">
        <strong>
          Ver Mais
          <i class="fa fa-plus-square" style="font-size:14px;"></i>
        </strong>
      </b-button>
      <h4>
        <strong>{{titulo}}</strong>
      </h4>
    </div>
    <apexchart v-if="ready" id="chart" type="bar" height="350" :options="options" :series="series" />
  </div>
</template>

<script>
export default {
  name: "Segmentacao",
  data: _ => {
    return {
      ready: false,
      options: {
        chart: {
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: [2, 4, 4]
        },
        xaxis: {
          categories: [],
          labels: {
            trim: true,
            rotate: 0,
            rotateAlways: false
          }
        },
        yaxis: [
          {
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: "#008FFB"
            },
            labels: {
              formatter: function(val, index) {
                return val.toFixed(2);
              },
              style: {
                color: "#008FFB"
              }
            },
            title: {
              text: "Venda",
              style: {
                color: "#008FFB"
              }
            }
          },
          {
            seriesName: "Lucro total",
            opposite: true,
            axisTicks: {
              show: true
            },
            axisBorder: {
              show: true,
              color: "#00E396"
            },
            labels: {
              style: {
                color: "#00E396"
              }
            },
            title: {
              text: "Lucro",
              style: {
                color: "#00E396"
              }
            }
          }
        ],
        tooltip: {
          enabled: true,
          shared: true,
          fixed: {
            enabled: true,
            position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
            offsetY: 30,
            offsetX: 60
          }
        },
        legend: {
          horizontalAlign: "left",
          offsetX: 40
        }
      },
      series: [
        {
          data: []
        }
      ]
    };
  },
  watch: {
    categories(newValue, oldValue) {
      if (newValue != oldValue) this.updateData();
    },
    data(newValue, oldValue) {
      if (newValue != oldValue) this.updateData();
    }
  },
  props: ["titulo", "url", "categories", "series"],
  methods: {
    redirecionar() {
      this.$router.push(`produtos/${this.url}`);
    },
    updateData() {
      this.options = {
        ...this.options,
        ...{
          xaxis: {
            categories: this.categories
          }
        }
      };
      this.series = [
        {
          data: this.data
        }
      ];
      this.ready = true;
    }
  },
  mounted() {
    this.options.xaxis.categories = this.categories;
    this.series = this.series;
    console.info({
      pagina: this.titulo,
      categorias: this.categories,
      data: this.data
    });
    this.ready = true;
  }
};
</script>